<template>
  <transition name="fade" @after-leave="handleAfterLeave">
    <div
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
      class="ly-message show-hide"
      :class="type"
      v-if="visible"
    >
      <i class="icon-type iconfont" :class="'icon-' + type"></i>
      <div class="content">
        {{ content }}
        <!-- <i
          v-if="hasClose"
          class="btn-close iconfont icon-close"
          @click="visible = false"
        ></i> -->
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LyMessage",
  data() {
    return {
      timer: null,
      content: "",
      duration: 2000,
      visible: false,
      type: "info", //'info','success','error'
      hasClose: false
    };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.visible = false;
          }
        }, this.duration);
      }
    },
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .1s ease;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.show-hide {
  animation: showhide 1s ease;
  -moz-animation: showhide 1s;	/* Firefox */
  -webkit-animation: showhide 1s;	/* Safari 和 Chrome */
  -o-animation: showhide 1s;
}
@-webkit-keyframes showhide {
  0% {
    opacity: 0;
    top: -100%;
  }
  20% {
    opacity: 20%;
    top: 0;
  }
  100%{
    opacity: 1;
    top: 120px;
  }
}
.ly-message {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  width: 372px;
  display: none;
  align-items: center;
  overflow: visible;
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  padding: 0 11px;
  border-radius: 0;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  top: 120px;
  z-index: 9999;
  transform: translateX(-50%);
  cursor: pointer;
  .icon-type {
    position: absolute;
    left: 11px;
    top: 50%;
    z-index: 10000;
    transform: translatey(-50%);
  }
  &.info,
  &.success,
  &.error {
    display: flex;
    &:before,
    &:after {
      width: 380px;
      height: 20px;
      position: absolute;
      left: -4px;
      content: "";
      display: block;
      background-size: 100%;
    }
  }
  &.info {
    background: url("./images/info-middle.png") repeat-y;
    background-size: contain;
    .icon-info {
      display: inline-block;
      width: 22px;
      height: 25px;
      background: url("./images/icon-info.png") no-repeat;
      background-size: contain;
    }
    .content {
      color: rgba(0, 178, 255, 1);
      padding-left: 33px;
    }
    &:before {
      top: -20px;
      background: url("./images/info-top.png") no-repeat;
      background-size: cover;
    }
    &:after {
      bottom: -20px;
      background: url("./images/info-bottom.png") no-repeat;
      background-size: cover;
    }
  }
  &.success {
    background: url("./images/success-middle.png") repeat-y;
    background-size: contain;
    .icon-success {
      display: inline-block;
      width: 31px;
      height: 33px;
      background: url("./images/icon-success.png") no-repeat;
      background-size: contain;
    }
    .content {
      color: rgba(0, 255, 249, 1);
      padding-left: 42px;
    }
    &:before {
      top: -20px;
      background: url("./images/success-top.png") no-repeat;
      background-size: cover;
    }
    &:after {
      bottom: -20px;
      background: url("./images/success-bottom.png") no-repeat;
      background-size: cover;
    }
  }
  &.error {
    background: url("./images/error-middle.png") repeat-y;
    background-size: contain;
    .icon-error {
      display: inline-block;
      width: 27px;
      height: 24px;
      background: url("./images/icon-error.png") no-repeat;
      background-size: contain;
    }
    .content {
      color: rgba(250, 87, 87, 1);
      padding-left: 38px;
    }
    &:before {
      top: -20px;
      background: url("./images/error-top.png") no-repeat;
      background-size: cover;
    }
    &:after {
      bottom: -20px;
      background: url("./images/error-bottom.png") no-repeat;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Message/index.vue